import ChatBot from './ChatBot';

export default ChatBot; 